import { render, staticRenderFns } from "./BallotResult.vue?vue&type=template&id=4ae85854&scoped=true&"
import script from "./BallotResult.vue?vue&type=script&lang=ts&"
export * from "./BallotResult.vue?vue&type=script&lang=ts&"
import style0 from "./BallotResult.vue?vue&type=style&index=0&id=4ae85854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae85854",
  null
  
)

export default component.exports